import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import {
  CREATE_USER_MUTATION,
  EDIT_USER_MUTATION,
} from 'src/graphql/user/mutation';
import { REFETCH_USERS_LIST_QUERIES } from './constants';

export default isNew => {
  const mutation = isNew ? CREATE_USER_MUTATION : EDIT_USER_MUTATION;
  const [upsertUser] = useMutation(mutation);

  return useCallback(
    ({ id, firstName, lastName, email, login, timezoneId, roleIds, filteringRuleGroupIds, active = true, isThirdPartyUser = false }) =>
      upsertUser({
        variables: {
          id,
          firstName,
          lastName,
          email,
          login: login || email,
          timezoneId,
          roleIds,
          filteringRuleGroupIds,
          active,
          isThirdPartyUser
        },
        refetchQueries: () => REFETCH_USERS_LIST_QUERIES,
      }),
    [],
  );
};
